module.exports = __webpack_public_path__ + "img/teams-grid-zoom-minus-clicked.29ac227b.svg";